function decodeQuery(queryStr) {
  let query = {};
  queryStr = decodeURI(queryStr.replace('?', ''));
  let queryArr = queryStr.split('&');
  queryArr.forEach((item) => {
    let keyAndValue = item.split('=');
    query[keyAndValue[0]] = keyAndValue[1];
  });
  return query;
}

export { decodeQuery };
